
// UPDATE 数据更新
export const UPDATE_MY_INFO = 'myInfo'
export const UPDATE_PLAYER = 'player'
export const UPDATE_CUP = 'cup'
export const UPDATE_CUP_PLAYER = 'cupPlayer'
export const UPDATE_GAME = 'game'
export const UPDATE_GAMES = 'games'
export const UPDATE_KLINES = 'klines'
export const UPDATE_MY_DETAIL = 'myDetail'
export const UPDATE_MY_ADDRESS = 'myAddress'
export const UPDATE_MY_OPEN_INFO = 'myOpenId'
export const UPDATE_OAUTH_ADDRESS = 'oauthAddress'
export const UPDATE_MY_DK_GAMES = 'myDKGames'
export const UPDATE_MY_DK_CUP_LAYERS = 'myDKCupPlayers'
export const UPDATE_MY_REALITY_GAMES = 'myRealityGames'
export const UPDATE_NEXT_TRADING_DAY = 'nextTradingDay'


export const UPDATE_PLAY = 'play'
export const UPDATE_PLAY_CUP_ID = 'playCupId'
export const UPDATE_PLAY_GAME_ID = 'playGameId'
export const UPDATE_PLAY_KLINES = 'playKlines'

export const UPDATE_PRE_RANK = 'preRank'
export const UPDATE_FINAL_RANK = 'finalRank'
export const UPDATE_WINNERS = 'winners'

export const UPDATE_ADDRESS_LIST = 'addressList'

export const UPDATE_REALITY_RANKS = 'realityRank'
export const UPDATE_MY_RANK = 'myRank'
export const UPDATE_USERS = 'users'

export const UPDATE_CONFIG = 'config'
export const UPDATE_BLOCKS = 'blocks'

export const UPDATE_NOW_TIME = 'nowTime'

// export const UPDATE_PLAY_CUP_ID = 'UPDATE_PLAY_CUP_ID'
// export const UPDATE_PLAY_GAME_ID = 'UPDATE_PLAY_GAME_ID'
// export const UPDATE_PLAY_KID = 'UPDATE_PLAY_KID'
// export const UPDATE_PLAY_KLINES = 'UPDATE_PLAY_KLINES'

export const SET_NAV = 'setNav'
export const SHOW_NAV = 'showNav'
export const HIDE_NAV = 'hideNav'

// 计时器
export const TIMER_START = 'timerStart'
export const TIMER_STOP = 'timerStop'

// SETTING 用户设置
export const SETTING_MA = 'settingMA' // 设置可显示的均线
